import { debug } from '../app';

export enum MenuState {
    Closed,
    Opening,
    Open,
    Closing
};

export class Menu extends EventTarget {
    private _isMenuOpen: boolean = false;
    private menuAnimationTimeout: number;
    private _menuState: MenuState = MenuState.Closed;

    private menuElement: HTMLElement | null;
    private menuButton: HTMLElement | null;

    constructor(_menuElement: HTMLElement | null = null, _menuButton: HTMLElement | null = null) {
        super();
        this.menuElement = _menuElement;
        this.menuButton = _menuButton;
        this.addListeners();
        debug ? console.log('Menu initialized') : null;
    }

    private addListeners = () => {
        if (this.menuButton) {
            this.menuButton.addEventListener('click', () => this.toggleMenu());
        }
        if (this.menuElement) {
            const menuLinks = this.menuElement.querySelectorAll('a');
            menuLinks.forEach((link) => {
                link.addEventListener('click', () => {
                    debug ? console.log('Menu link clicked') : null;
                    this.closeMenu();
                });
                link.addEventListener('mouseenter', () => {
                    debug ? console.log('Menu link mouseenter') : null;
                    this.dispatchEvent(new CustomEvent('mouseenter', { detail: link}));
                });
                link.addEventListener('mouseleave', () => {
                    debug ? console.log('Menu link mouseleave') : null;
                    this.dispatchEvent(new CustomEvent('mouseleave', { detail: link}));
                });
            });
        }
    }

    private get menuState(): MenuState {
        return this._menuState;
    }

    private set menuState(value: MenuState) {
        if (this._menuState !== value) {
            this._menuState = value;
            this.dispatchEvent(new CustomEvent('menuStateChange', { detail: this._menuState }));

            if (this.menuElement) {
                switch (this._menuState) {
                    case MenuState.Open:
                        this.menuElement.classList.remove('-opening');
                        this.menuElement.classList.add('-active');
                        break;
                    case MenuState.Closed:
                        this.menuElement.classList.remove('-closing');
                        break;
                    case MenuState.Opening:
                        this.menuElement.classList.add('-opening');
                        break;
                    case MenuState.Closing:
                        this.menuElement.classList.remove('-active');
                        this.menuElement.classList.add('-closing');
                        break;
                }
            }
        }
    }
  
    public get isMenuOpen(): boolean {
        return this._isMenuOpen;
    }

    public set isMenuOpen(value: boolean) {
        if (this.menuButton && this.menuElement) {
            
            // open closed menu
            if (this.menuState === MenuState.Closed && value === true) {
                clearTimeout(this.menuAnimationTimeout);
                
                this.menuState = MenuState.Opening;
                this.menuAnimationTimeout = window.setTimeout(() => {
                    this.menuState = MenuState.Open;
                    this._isMenuOpen = true;
                    this.dispatchEvent(new Event('change'));
                }, 500);
            }

            // close open menu
            if (this.menuState === MenuState.Open && value === false) {
                clearTimeout(this.menuAnimationTimeout);
                
                this.menuState = MenuState.Closing;
                this.menuAnimationTimeout = window.setTimeout(() => {
                    this.menuState = MenuState.Closed;
                    this._isMenuOpen = false;
                }, 500);
            }
        }
    }

    public toggleMenu = () => {
        this.isMenuOpen = !this.isMenuOpen;
    }

    public closeMenu = () => {
        this.isMenuOpen = false;
    }

    public reinitialize = () => {
        this.addListeners();
    }
}